// Supabase client configuration
// Uses environment variables for security - never hardcode credentials
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Environment variables with fallbacks for backward compatibility
// In production, always set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://culbbccjfjzqwnxyjfng.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN1bGJiY2NqZmp6cXdueHlqZm5nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIwNDYzNjksImV4cCI6MjA1NzYyMjM2OX0.KouR7nVw2CBq_pPsG-f1aHg7qLwpDFy9VnwUdORzMHI";

// Log warning if using fallback values (for debugging)
if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY) {
    console.warn(
        'Supabase environment variables not found, using fallback values. ' +
        'For better security, set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY in your environment.'
    );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);